import { action } from "nanostores";

import { $visualizer } from "@/stores/visualizer";

export const toggleShowDims = action($visualizer, "toggle show dims", store => {
  store.setKey("showDims", !store.get().showDims);
});

export const changeDims = action(
  $visualizer,
  "toggle show dims",
  (store, value) => {
    store.setKey("showDims", value);
  }
);
